import styled from "@emotion/styled";
import type { CSSObject } from "@emotion/react";
import TextField from "@mui/material/TextField";
import { cvar } from "styles";

export const InputContainer = styled("div")(
  (): CSSObject => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  }),
);

export const LabelGroupWrapper = styled("div")(
  (): CSSObject => ({
    display: "flex",
    flexDirection: "column",
    height: "20px",
  }),
);

export const StyledFormLabel = styled("div")(() => ({
  fontFamily: "Barlow",
  fontSize: "10px",
  fontWeight: "600",
  lineHeight: "9px",
  marginBottom: "8px",
  color: cvar("nepal-blue"),
  textTransform: "uppercase",
}));

export const StyledTextField = styled(TextField)(() => ({
  marginBottom: "12px",
  borderRadius: "3px",

  "& .MuiOutlinedInput-root": {
    boderColor: "pink",
    "& > fieldset": { borderColor: cvar("botticelli-blue") },
    "&.Mui-focused fieldset": {
      // borderColor: cvar("botticelli-blue"),
    },
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: `${cvar("botticelli-blue")} !important`,
  },
  "& .Mui-disabled": {
    background: cvar("cotton-boll"),
    borderRadius: "3px",
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: cvar("queen-blue"),
  },
}));

export const StyledPrefix = styled("text")(() => ({
  color: cvar("dark-blue"),
  fontSize: "16px",
  fontWeight: "500",
}));
